import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';

import { DatasetColumn } from '@blaze-shared/schema-domain';

import { BulkEditComponent } from '../components/bulk-edit/bulk-edit.component';

import { DialogBackdropService } from './dialog/dialog-backdrop.service';

@Injectable({ providedIn: 'root' })
export class BulkEditService {
  private readonly dialog = inject(MatDialog);
  private readonly dialogBackdropService = inject(DialogBackdropService);

  open(columns: DatasetColumn[]): Observable<any> {
    const dialogRef = this.dialog.open(BulkEditComponent, {
      minWidth: '376px',
      maxWidth: '60vw',
      height: 'auto',
      hasBackdrop: true,
      backdropClass: 'bd-overlay-appearance',
      panelClass: ['bd', 'bd-dialog', 'bg-bat'],
      data: { columns },
    });

    this.dialogBackdropService.attachBackdropStyles();
    return dialogRef.afterClosed();
  }
}
